import { FC, useState } from 'react';

import { Button, Heading, NotificationBox, RadioGroup, RadioTile, Stack, Stretch, Text } from '@eneco/sparky';
import { NotificationBarProps } from '@eneco/sparky/types';
import { useTracking } from '@eneco/tracking';
import { useContent } from '@sitecore/common';
import { PriceSimulationRenderingExtended } from '@sitecore/types/manual/be/PriceSimulationExtended';
import { useFormContext } from 'react-hook-form';

import { PriceSimulationFormSchema } from '../schemas/priceSimulationFormSchema';
import { FlowChildProps } from '../types/PriceSimulationSteps';
import { getTrackableFormValues } from '../utils/getTrackableFormValues';

export const FlowSelectorStep: FC<FlowChildProps> = ({ nextMainStep }) => {
  const { fields } = useContent<PriceSimulationRenderingExtended>();
  const { getValues } = useFormContext<PriceSimulationFormSchema>();
  const { trackEventBE } = useTracking();

  const [flow, setFlow] = useState<string | undefined>('productSimulation');
  const [error, setError] = useState<NotificationBarProps | null>(null);
  const flowLinkMapping = new Map<string | undefined, string>([
    ['movingOut', fields.actionSelectionStep.moveLink.value.href],
    ['productChange', fields.actionSelectionStep.productSwitchLink.value.href],
  ]);

  const onNextClick = () => {
    if (flow === undefined) {
      setError({
        variant: 'error',
        title: fields.summaryStep.errorNotification.value.title,
        text: fields.actionSelectionStep.actionTypesList.value.requiredMessage,
      });
      return;
    }
    if (flow === 'productSimulation') {
      trackEventBE('pbt_flowSelector', {
        status: 'click',
        data: getTrackableFormValues(getValues()),
      });
      nextMainStep();
    } else {
      const href = flowLinkMapping.get(flow);
      if (href) {
        window.location.href = href;
      }
    }
  };

  return (
    <>
      <Stack gap="2">
        <Heading as="h1" size="M">
          {fields.actionSelectionStep.title.value}
        </Heading>
        <Text>{fields.actionSelectionStep.navigationTitle.value}</Text>
      </Stack>
      <Stretch>
        <div>
          <RadioGroup
            aria-labelledby={fields.actionSelectionStep.actionTypesList.value.label}
            direction="column"
            name="existingCustomerCheck"
            value={flow}
            onValueChange={val => setFlow(val)}>
            {fields.actionSelectionStep.actionTypesList.value.options.map(option => {
              return (
                <RadioTile key={option.name} value={option.name}>
                  {option.label}
                </RadioTile>
              );
            })}
          </RadioGroup>
        </div>
      </Stretch>
      {error && <NotificationBox variant="error" isAlert {...error} />}
      <Stack gap="2" direction="row">
        <Button onClick={onNextClick}>{fields.navigation.nextButtonText.value}</Button>
      </Stack>
    </>
  );
};
